import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              焦点追踪
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              最新热点爆料专题，深度追踪娱乐内幕
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/9] overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={`吃瓜爆料焦点追踪 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-display text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {item.summary}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                      {item.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                      {item.views}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}